export const StartTrialContent = {
  ADE: {
    title: "A.AVA ADE",
    header: "We welcome you to try A.AVA ADE",
    content:
      "You could continue using A.AVA ADE after your trial period, by purchasing the software.",
    statement: "You can get a first-hand experience doing the following",
    actions: [
      'Generate Data synthetically using "Synthetic Data Generator"',
      'Pattern Analysis using "Data Finger-Print and Analyzer"',
      'Data Migration Advisory using "Migration Advisor"',
      'Get insights into the data using "Data Profiler"',
    ],
  },
  ITA: {
    title: "A.AVA ITA",
    header: "We welcome you to try A.AVA ITA",
    content:
      "You could continue using A.AVA ITA after your trial period, by purchasing the software.",
    statement:
      "You can get a first hand experience on how to perform requirement analysis, \ndata management requests and manage test execution. \nYou can also do the following:",
    actions: [
      "Access to perform Data Management Request",
      "Access to perform Requirement Analysis",
      "Access to manage Test Executions",
    ],
  },
  IAF: {
    title: "A.AVA IAF",
    header: "We welcome you to try A.AVA IAF",
    content:
      "You could continue using A.AVA IAF after your trial period, by purchasing the software.",
    statement: "You can get a first hand experience doing the following",
    actions: [
      "To perform Accessibility website Scanning (Maximum of 5 URLs scanning at an instance)",
      "View the Intelligent Accessibility Testing Score (IAF Score) of the website with the \n statistics of voilations (categorized into Critical, Serious, Moderate and Minor)",
      "View and Download the Accessibility Report",
      "Give your feedback on the Remediation Code/Suggestion for the Voilations",
    ],
  },
};
